
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import cseh from "../../assets/cseh.png"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"

function MagyarCseh({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar cseh fordító</title>
                <meta name='description' content="Ingyenes magyar cseh fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar cseh fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-cseh-fordito" />
            </Helmet>
            <h1>Magyar cseh fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A magyar és cseh nyelv </h2>
                    <img src={magyar} alt="magyar zászló"></img>
                    <img src={cseh} alt="cseh zászló"></img>

                </div>

                <p>Íme néhány fő hasonlóság és különbség a cseh és a magyar között:</p>

                 <h3>Hasonlóságok</h3>

                 <li><b>Nyelvtani esetek</b>: Mind a cseh, mind a magyar esetrendszer gazdag, ahol a főnevek, névmások és melléknevek alakja megváltozik, hogy a mondaton belüli nyelvtani kapcsolatokat és funkciókat jelezze.</li>
                 <li><b>Kiejtés</b>: Mindkét nyelvnek viszonylag fonetikus a helyesírása, ami azt jelenti, hogy a szavakat általában úgy ejtik ki, ahogy írják őket.</li>
                
                
                 <h3>Különbségek</h3>

                 <li><b>Nyelvcsalád</b>: A cseh egy nyugatszláv nyelv, amely az indoeurópai nyelvcsaládhoz tartozik. A magyar viszont finnugor nyelv, az uráli nyelvcsalád része. Ez azt jelenti, hogy a két nyelvnek eltérő nyelvi gyökerei vannak, és nem állnak szoros rokonságban.</li>
                 <li><b>Szókincs</b>: A cseh és a magyar nyelvnek eltérő szókincse van, mivel eltérő nyelvcsaládjuk. Míg a cseh néhány szót más szláv nyelvekből kölcsönzött, és hatással van a német és a latin nyelvre, addig a magyar egyedi szókinccsel rendelkezik, amely nem kapcsolódik szorosan más európai nyelvekhez.</li>
                 <li><b>Nyelvtan</b>: Bár mind a cseh, mind a magyar nyelvtani rendszer bonyolult, bizonyos szempontok szerint különböznek egymástól. A cseh nyelvnek összetett igeragozási rendszere van, különböző alakokkal, különböző személyekre, számokra és igeidőkre. A magyar nyelvnek viszont van egy egyedülálló agglutinatív nyelvtana, ahol a szótövekhez utótagokat adnak, hogy kifejezzék a különböző nyelvtani jellemzőket, mint például az idő, a mód és a birtoklás.</li>
                 <li><b>Mondatszerkezet</b>: A cseh nyelv az indoeurópai nyelvcsaládban általánosan elterjedt SVO (Subject-Ige-Object) mondatszerkezetet követi. A magyar nyelvnek azonban Subject-Object-Verb (SOV) mondatszerkezete van, ami eltér az európai nyelvek tipikus szórendjétől.</li>
                 <li><b>Kiejtés</b>: A cseh nyelvnek viszonylag bonyolult fonetikai rendszere van, sok olyan hanggal, amelyek esetleg ismeretlenek a más nyelveket beszélők számára. A magyar nyelvnek van néhány egyedi hangzása, de egyszerűbb a hangrendszere, következetes kiejtési szabályokkal.</li>





                <div className="sectionbottom">
                    <Link to="/cseh-magyar-fordito">Cseh magyar fordító</Link>
                    <img src={cseh} alt="cseh zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>

            </section>
        </>

    )
}

export default MagyarCseh;